import { render, staticRenderFns } from "./OverviewModuleFooter.vue?vue&type=template&id=2ee78656&scoped=true"
import script from "./OverviewModuleFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewModuleFooter.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OverviewModuleFooter.vue?vue&type=style&index=0&id=2ee78656&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee78656",
  null
  
)

export default component.exports